import React, { useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { InputGroup, Input, InputRightElement, Image } from '@chakra-ui/react';
import { calendarInput } from '../../assets/new-images/icons';
import 'react-datepicker/dist/react-datepicker.css';

/**
 * YearPickerInput — campo de seleção de ano usando react-datepicker.
 * Não vinculado ao react-hook-form; recebe value (Date | null) e onChange.
 */
const YearPickerInput = ({ value, onChange, placeholder = 'Exercício', w = '210px' }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <InputGroup display='grid' isolation='unset' width={w}>
      <ReactDatePicker
        selected={value}
        onChange={(date) => {
          onChange(date);
          setIsOpen(false);
        }}
        showYearPicker
        dateFormat='yyyy'
        openToDate={new Date()}
        placeholderText={placeholder}
        autoComplete='off'
        open={isOpen}
        onInputClick={() => setIsOpen(true)}
        onClickOutside={() => setIsOpen(false)}
        customInput={
          <Input
            aria-label={placeholder}
            autoComplete='off'
            type='text'
            readOnly
            onClick={() => setIsOpen(true)}
            _autofill={{
              bg: '#F5F5FB !important',
              WebkitBoxShadow: '0 0 0px 1000px #F5F5FB inset',
              WebkitTextFillColor: '#000000',
              transition: 'background-color 5000s ease-in-out 0s',
            }}
            _focusVisible={{ borderColor: 'inherit' }}
          />
        }
      />
      <InputRightElement
        pointerEvents='none'
        display='flex'
        alignItems='center'
        h='100%'
        cursor='pointer'
      >
        <Image src={calendarInput} alt='calendar' mr='10px' height='23px' />
      </InputRightElement>
    </InputGroup>
  );
};

export default YearPickerInput;
